var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper", style: { backgroundColor: _vm.backgroundColor } },
    [
      _c(
        "svg",
        { attrs: { xmlns: "http://www.w3.org/2000/svg", version: "1.1" } },
        [
          _c("defs", [
            _c(
              "filter",
              {
                attrs: {
                  id: "goo",
                  x: "-50%",
                  y: "-50%",
                  width: "200%",
                  height: "200%",
                },
              },
              [
                _c("feGaussianBlur", {
                  attrs: {
                    in: "SourceGraphic",
                    stdDeviation: "2",
                    result: "blur",
                  },
                }),
                _vm._v(" "),
                _c("feColorMatrix", {
                  attrs: {
                    in: "blur",
                    mode: "matrix",
                    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -1",
                    result: "goo",
                  },
                }),
                _vm._v(" "),
                _c("feBlend", { attrs: { in: "SourceGraphic", in2: "goo" } }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "loader" }, [
        _c("span", { style: { backgroundColor: _vm.color } }),
        _vm._v(" "),
        _c("span", { style: { backgroundColor: _vm.color } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }